export const LazyLinkSignatureRepository = Symbol.for('LazyLinkSignatureRepository');
